<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5">
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">Fees Increase Request Entry</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #feesIncreaseForm="ngForm" class="pb-3">
                            <div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="form-label "><b>Academic year</b><span class="text-danger">
                                                    *</span></label>
                                            <select class="form-control" #AcademicYearID="ngModel" ngModel
                                                name="AcademicYearID" id="AcademicYearID"
                                                [(ngModel)]="data.AcademicYearID" required>
                                                <option *ngFor="let year of years" [value]="year.value"
                                                    [selected]="data.AcademicYearID == year.value">
                                                    {{ year.text }}
                                                </option>
                                            </select>
                                            <span *ngIf="submitted ">
                                                <p *ngIf="data.AcademicYearID == 0 || data.AcademicYearID == undefined"
                                                    class="error_message" style="color: red">
                                                    Academic year is required
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="form-label "><b>Medium</b><span class="text-danger">
                                                    *</span></label>
                                            <select class="form-control" #MediumID="ngModel" ngModel name="MediumID"
                                                id="MediumID" [(ngModel)]="data.MediumID" required>
                                                <option *ngFor="let medium of mediums" [value]="medium.value"
                                                    [selected]="data.MediumID == medium.value">
                                                    {{ medium.text }}
                                                </option>
                                            </select>
                                            <span *ngIf="submitted ">
                                                <p *ngIf="data.MediumID == 0 || data.MediumID == undefined"
                                                    class="error_message" style="color: red">
                                                    Medium is required
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="form-label "><b>Course</b><span class="text-danger">
                                                    *</span></label>
                                            <select class="form-control" #CourseID="ngModel" ngModel name="CourseID"
                                                id="CourseID" (change)="fillCourseYear(0)" [(ngModel)]="data.CourseID"
                                                required>
                                                <option *ngFor="let std of stds" [value]="std.value"
                                                    [selected]="data.CourseID == std.value">
                                                    {{ std.text }}
                                                </option>
                                            </select>
                                            <span *ngIf="submitted ">
                                                <p *ngIf="data.CourseID == 0 || data.CourseID == undefined"
                                                    class="error_message" style="color: red">
                                                    Course is required
                                                </p>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label class="form-label "><b>Course Year</b><span class="text-danger">
                                                    *</span></label>
                                            <select class="form-control" #CourseYearID="ngModel" ngModel
                                                name="CourseYearID" id="CourseYearID" [(ngModel)]="data.CourseYearID"
                                                required>
                                                <option selected value="0"> Select </option>
                                                <option *ngFor="let std of courseyears" [value]="std.value"
                                                    [selected]="data.CourseYearID == std.value">
                                                    {{ std.text }}
                                                </option>
                                            </select>
                                            <span *ngIf="submitted ">
                                                <p *ngIf="data.CourseYearID == 0 || data.CourseYearID == undefined"
                                                    class="error_message" style="color: red">
                                                    Course year is required
                                                </p>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                </div>
                                <div class="mb-3">
                                    <button class="btn btn-success" type="button" (click)="showDetail()" id="btnShow"
                                        style="margin: 5px;">Show</button>
                                    <button class="btn btn-primary" type="button" (click)="resetForm()" id="btnReset"
                                        style="margin: 5px;display: none;">Reset</button>
                                    <button class="btn btn-danger" type="button" style="margin: 5px;"
                                        (click)="cancel()">Cancel</button>
                                </div>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div *ngIf="feesIncreaselist.length != 0">
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col">Sr. No.</th>
                                                    <th class="pointer" scope="col"> Fees Head </th>
                                                    <th class="pointer" scope="col">Fees Amount (Current Amount)</th>
                                                    <th class="pointer" scope="col">Updated Amount</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    *ngFor="let r of feesIncreaselist | filter:searchtext ;let i = index">
                                                    <td>
                                                        {{i+ 1}}
                                                    </td>
                                                    <td>
                                                        <p>{{r.FeesHead}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.FeesAmountActual}}</p>
                                                    </td>
                                                    <td>
                                                        <input type="text" class="form-control" id="newAmt{{i}}"
                                                            name="newAmt{{i}}" value="{{r.FeesAmount}}"
                                                            (keypress)="onlyDouble($event);"
                                                            (change)="calculateTotal()" />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2">Total</td>
                                                    <td>{{totalFeesAmount}}</td>
                                                    <td>{{NewtotalFeesAmount}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="feesIncreaselist.length != 0">
                            <div class="col-lg-6 col-md-6 col-6">
                                <label class="form-label "><b>Remark</b></label>
                                <textarea class="form-control" type="text" placeholder="Enter remark" id="Remark"
                                    #Remark="ngModel" ngModel name="Remark" id="Remark" [(ngModel)]="data.Remark"
                                    ngModel maxlength="300" autocomplete="off"></textarea>
                            </div>
                        </div>
                        <div class="row" *ngIf="feesIncreaselist.length != 0">
                            <div class="col-lg-6 col-md-6 col-6">
                                <button class="btn btn-success" type="button" style="margin: 5px;"
                                    (click)="addNewRequest()">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" style="margin: 5px;" (click)="cancel()">
                                    Cancel </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>